import { DeleteOutlined } from '@ant-design/icons';
import { FormItem, TextInput, useField } from '@framework/form';
import { Button } from 'antd';
import { i } from 'mathjs';
import React from 'react';
import { $LabeledSpaceCompact } from '../../../../../../../ui/form/SpaceCompact';
import { IAsyncService } from '../../../../../../expressions/repository/async/context/IAsyncService';
import { ServiceOutputSelect } from '../ServiceOutputSelect';

export interface IAsyncSelectServiceColumnConfigProps {
  index: number;
  service: IAsyncService;
  onDelete: () => void;
}

/**
 * Campo di configurazione per la colonna di una tabella di un async select widget.
 */
export function AsyncSelectServiceColumnConfig(
  props: IAsyncSelectServiceColumnConfigProps,
) {
  const { index, service, onDelete } = props;

  const labelField = useField<string | undefined>(
    `table.columns.${index}.label`,
  );

  return (
    <$LabeledSpaceCompact block size="large" key={i}>
      <FormItem name={`table.columns.${index}.value`} label={'Valore'}>
        <ServiceOutputSelect
          service={service}
          name={`table.columns.${index}.value`}
          onChange={(value, _, onChange) => {
            onChange(value);
            if (!labelField.getValue()) {
              labelField.setValue(value);
            }
          }}
        />
      </FormItem>
      <FormItem name={`table.columns.${index}.label`} label={'Etichetta'}>
        <TextInput name={`table.columns.${index}.label`} />
      </FormItem>
      <Button
        onClick={onDelete}
        danger
        icon={<DeleteOutlined aria-label="Rimuovi colonna" />}
      />
    </$LabeledSpaceCompact>
  );
}
